import React, {Fragment} from 'react';
import Navbar from '../../components/Navbar/Navbar'
import Hero3 from '../../components/hero3/Hero3';
import Features from '../../components/Features/Features';
import WorkProcess from '../../components/WorkProcess/WorkProcess';
import About from '../../components/about/about';
import ServiceSection from '../../components/ServiceSection/ServiceSection';
import Testimonial from '../../components/Testimonial/Testimonial';
import ProjectSection from '../../components/ProjectSection/ProjectSection';
import FunFact from '../../components/FunFact/FunFact';
import TeamSection from '../../components/TeamSectionS2/TeamSectionS2';
import PartnerSection from '../../components/PartnerSection2/PartnerSectionS2';
import ContactSection from '../../components/ContactSection/ContactSection';
import BlogSection from '../../components/BlogSection/BlogSection';
import Footer from '../../components/footer/Footer';
import Scrollbar from '../../components/scrollbar/scrollbar';
import Logo from '../../images/ffsdgroupwhite.png'
import Navbar2 from '../../components/Navbar2/Navbar2';
import Login from '../../components/Login/Login';

const HomePage4 =() => {
    return(
        <Fragment>
            <Navbar hclass={'header-style-1'}  Logo={Logo}/>
            {/* <Navbar2 hclass={'header-style-2'} Logo={Logo} /> */}
            <Hero3/>
            <Features/>
            <About/>
            {/* <Login /> */}
            <ServiceSection/>
            <FunFact/>
            {/* <TeamSection/> */}
            <PartnerSection/>
            <Footer/> 
            <Scrollbar/>
        </Fragment>
    )
};
export default HomePage4;